import React, { useState } from 'react';
import axios from 'axios';
import { Form, Button, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import './AdminCSS/operations.css';
// import { API_URL } from '../../config/config';

const API_URL = process.env.REACT_APP_API_URL;


const AddPatient = () => {
  const [name, setName] = useState('');
  const [age, setAge] = useState('');
  const [gender, setGender] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

 const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    const token = sessionStorage.getItem('access_token') || localStorage.getItem('access_token');

    const response = await axios.post(
      `${API_URL}/patient/patients/`,
      {
        patient_name: name, // 🔹 match backend field
        age: parseInt(age),
        gender,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );

    setMessage(`Patient added successfully! ID: ${response.data.patient_id}`);
    setName('');
    setAge('');
    setGender('');
  } catch (error) {
    console.error('Error adding patient:', error);

    if (error.response && error.response.status === 401) {
      setMessage('Unauthorized: Please log in again.');
      navigate('/login');
    } else {
      setMessage(error.response?.data?.detail || 'Error adding patient');
    }
  }
};


  const handleClose = () => {
    navigate('/admindashboard');
  };

  return (
    <div className="add-patient-wrapper">
      <div className="add-patient-container">
        <div className="header">
          <h3>Add Patient</h3>
          <button className="close-button" onClick={handleClose}>&times;</button>
        </div>
        <Form onSubmit={handleSubmit}>
          <Form.Group>
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>Age</Form.Label>
            <Form.Control
              type="number"
              value={age}
              onChange={(e) => setAge(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>Gender</Form.Label>
            <Form.Control
              as="select"
              value={gender}
              onChange={(e) => setGender(e.target.value)}
              required
            >
              <option value="">Select</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Other">Other</option>
            </Form.Control>
          </Form.Group>

          <Button type="submit" className="btn btn-primary mt-3">
            Add Patient
          </Button>
        </Form>

        {message && <Alert variant="info" className="mt-3">{message}</Alert>}
      </div>
    </div>
  );
};

export default AddPatient;